export enum CompanyMandatoryData {
  REGISTRATION_DATE = 'registrationDate',
  ZIP = 'zip',
}
